import { Component, input, InputSignal, signal, inject } from '@angular/core';
import { ModalService } from '../../state/modal/modal.service';
import { FeedbackFormComponent } from '../feedback-form/feedback-form.component';
import { FeedbackFormData } from '../feedback-form/feedback-types';
import { FeatureType } from '@shared/interfaces/feedback';
import { RatingIconComponent } from '../rating-icon/rating-icon.component';
import { featureToFormDataMap } from '../../utils/feedback/feedback';

@Component({
  selector: 'app-feedback-card',
  imports: [RatingIconComponent],
  templateUrl: './feedback-card.component.html',
  styleUrl: './feedback-card.component.css',
})
export class FeedbackCardComponent {
  private modalService = inject(ModalService);

  public feature = input.required<FeatureType>();
  public subtitle = input<string>($localize`How likely are you to use a solution like this if it were available?`);
  protected ratings = [
    { rating: 0, label: $localize`Very unlikely` },
    { rating: 2.5, label: $localize`Somewhat unlikely` },
    { rating: 5, label: $localize`Neutral` },
    { rating: 7.5, label: $localize`Somewhat likely` },
    { rating: 10, label: $localize`Very likely` },
  ];

  protected openModal(rating: number) {
    const data = featureToFormDataMap[this.feature()];
    const formDataSignal = signal<FeedbackFormData>(data);
    const ratingSignal = signal<number>(rating);
    this.modalService.openModal(FeedbackFormComponent, {
      data: {
        rating: ratingSignal as unknown as InputSignal<number>,
        formData: formDataSignal as unknown as InputSignal<FeedbackFormData>,
        feature: this.feature,
      },
      confirmModalClose: true,
    });
  }
}
